import { useState } from 'react'
import { RotateCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import ConfirmDialog from './ConfirmDialog'
import { clearLocalData } from '../services/storage'

const Footer = ({ playbookId }: { playbookId: string }) => {
  const { t } = useTranslation()
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const handleResetClick = () => {
    setShowConfirmDialog(true)
  }

  const handleConfirmReset = async () => {
    setShowConfirmDialog(false)
    await clearLocalData(playbookId)
    window.location.reload()
  }

  const handleCancelReset = () => {
    setShowConfirmDialog(false)
  }

  return (
    <>
      <div className="shrink-0 bg-border flex justify-between items-center px-4 h-7 text-xs text-muted-foreground rounded-md">
        <button className="flex items-center gap-1" onClick={handleResetClick}>
          <RotateCw size={16} />
          {t('footer.reset', 'Reset')}
        </button>
        <a href="https://linkando.com/webplays" target="_blank">
          {t('footer.powered_by', 'About WebPlays')}
        </a>
      </div>
      {showConfirmDialog && (
        <ConfirmDialog
          title={t('footer.reset_confirm_title', 'Reset Progress')}
          message={t(
            'footer.reset_confirm_message',
            'Are you sure you want to reset your progress? All your data will be cleared.',
          )}
          onConfirm={handleConfirmReset}
          onCancel={handleCancelReset}
          confirmText={t('footer.reset_confirm_button', 'Reset')}
          cancelText={t('footer.reset_cancel_button', 'Cancel')}
        />
      )}
    </>
  )
}

export default Footer
